import type { QueryClient } from '@tanstack/react-query';

/**
 * Drop every cached dashboard figure so the next render asks the server again.
 *
 * Two prefixes, not one. `['dashboards']` covers the composed payload, the
 * saved layout and the catalog; `['dashboard']` covers the per-widget hooks in
 * `hooks/useDashboard.ts`, which is where the numbers on screen actually come
 * from. Invalidating only the plural prefix left every widget showing its
 * cached figures, so a refresh did nothing visible.
 */
export function invalidateDashboardQueries(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: ['dashboards'] });
  void queryClient.invalidateQueries({ queryKey: ['dashboard'] });
}
